interface WordByWordRevealOptions {
  initialDelayMs?: number;
  wordDelayMs?: number;
  onBeforeStart?: () => void;
  onUpdate: (nextText: string) => void;
  onComplete?: () => void;
}

export function startWordByWordReveal(
  fullText: string,
  {
    initialDelayMs = 0,
    wordDelayMs = 60,
    onBeforeStart,
    onUpdate,
    onComplete,
  }: WordByWordRevealOptions,
): () => void {
  const words = (fullText || '').split(/\s+/).filter(Boolean);
  let wordIndex = 0;
  let currentText = '';
  let cancelled = false;
  let currentTimeoutId: number | null = null;

  const clearCurrentTimeout = () => {
    if (currentTimeoutId !== null) {
      window.clearTimeout(currentTimeoutId);
      currentTimeoutId = null;
    }
  };

  const finish = () => {
    clearCurrentTimeout();
    if (!cancelled) {
      onComplete?.();
    }
  };

  const step = () => {
    if (cancelled) return;
    if (wordIndex >= words.length) {
      finish();
      return;
    }

    currentText += (wordIndex > 0 ? ' ' : '') + words[wordIndex];
    wordIndex += 1;
    onUpdate(currentText);

    currentTimeoutId = window.setTimeout(step, wordDelayMs);
  };

  currentTimeoutId = window.setTimeout(() => {
    if (cancelled) return;
    onBeforeStart?.();
    if (words.length === 0) {
      finish();
      return;
    }
    step();
  }, initialDelayMs);

  return () => {
    cancelled = true;
    clearCurrentTimeout();
  };
}
